import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _LANGUAGE_CONFIG;

// FIXME: Add Builder Pattern to the below configuration.
var AR = 'ar';
var EN = 'en';
var RTL = 'rtl';
var LTR = 'ltr';
var AR_CONFIG = {
  code: AR,
  displayName: 'Arabic',
  direction: RTL,
  currency: {
    code: 'OMR'
  }
};
var EN_CONFIG = {
  code: EN,
  displayName: 'English',
  direction: LTR,
  currency: {
    code: 'USD'
  }
};
var LANGUAGE_CONFIG = (_LANGUAGE_CONFIG = {}, _defineProperty(_LANGUAGE_CONFIG, AR, AR_CONFIG), _defineProperty(_LANGUAGE_CONFIG, EN, EN_CONFIG), _LANGUAGE_CONFIG);
export var DEFAULT_LANGUAGE = EN;
export var SUPPORTED_LANUGAGE = [EN, AR];
export default LANGUAGE_CONFIG;